import ServiceCount from "../../components/ServiceCount";
import ServiceBanner from "../../components/SuccessStories/ServiceBanner";
import Testimonial from "../../components/SuccessStories/Testimonial";
import styles from "../../styles/SuccessStories/SuccessStories.module.css";

const SuccessStories = () => {
  return (
    <div className={styles.successStoriesContainer}>
      <div>
        <div>
          <ServiceBanner />
        </div>
        <div>
          <Testimonial />
        </div>
        <div className={styles.successStoriesInnerContainer}>
          <ServiceCount />
        </div>
      </div>
    </div>
  );
};

export default SuccessStories;
